import React, { Fragment, useMemo, useEffect, useState } from "react";
import Model from "../../../../elements/CustomModel";
import { Modal } from "react-bootstrap";
import ModelBody from "../../../../elements/ModelBody";
import ModelFooter from "../../../../elements/ModelFooter";
import { Form as BootForm } from 'react-bootstrap';
import Form from "../../../../elements/CustomForm";
import Input from "../../../../elements/CustomInput";
// import NumaricInput from "../../../../elements/NumaricInput";
import Button from "../../../../elements/CustomButton";
import { Table } from "react-bootstrap";
import Select from "../../../../elements/CustomSelect";
import ReactSelect from "react-select";
import { SALES_PERSON_COMMISSION_REQUEST } from "../../../../../_utils/constants/SalesPerson";
import { connect } from "react-redux";

const AddEdit = ({
  SalesPersonCategory: { salesCommission },
  auth,
  isOpen,
  size,
  hideModel,
  handleSubmit,
  validated,
  handleChange,
  state,
  salesPersonId,
  isLoading,
  storeList,
  fetchSalesCommission,
  employeeOptions,
  handleEmployeeSelect,
}) => {
  const [salesStoreCommission, setSalesStoreCommission] = useState([]);
  const [tmpSelectedStoreList, setTmpSelectedStoreList] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  // two-line option: name (bold) over email (muted)
  const formatEmployeeOption = (option) => (
    <div>
      <div style={{ fontWeight: 600 }}>{option.label}</div>
      <div style={{ fontSize: "0.8rem", color: "#6c757d" }}>{option.email}</div>
    </div>
  );

  // match on both name and email while typing
  const filterEmployee = (candidate, input) => {
    if (!input) return true;
    const q = input.toLowerCase();
    return (
      (candidate.label || "").toLowerCase().includes(q) ||
      (candidate.data.email || "").toLowerCase().includes(q)
    );
  };

  const onEmployeeChange = (option) => {
    setSelectedEmployee(option);
    handleEmployeeSelect(option);
  };

  useEffect(() => {
    // Clear stale local state immediately so the form is blank while loading
    setSalesStoreCommission([]);
    setTmpSelectedStoreList([]);
    if(salesPersonId){
      fetchSalesCommission(auth[0]?.token,salesPersonId);
    }
  }, [salesPersonId])

  const addDisabledKey = (originalArray, comparisonArray) => {
    let tmpMatchedKey = []
    originalArray.map(item => {
        const match = comparisonArray.find(element => {
          // console.log('parseInt(element.StoreId)', parseInt(element.StoreId), item.value)
          return parseInt(element.StoreId) === item.value
        });
        if (match) {
            tmpMatchedKey.push(item.value)
        }
    });
    return tmpMatchedKey;
  }

  useEffect(() => {
    if(salesPersonId){
      // Guard: if Redux still holds data for a different person (stale response),
      // skip until the correct response arrives.
      if (salesCommission?.length > 0 && parseInt(salesCommission[0].UserId) !== parseInt(salesPersonId)) {
        return;
      }

      let tmpCommission = salesCommission?.[0]?.SalesCommission || []
      let tmpList = addDisabledKey(storeList, tmpCommission)
      setTmpSelectedStoreList(tmpList)
      // setTmpSelectedStoreList(storeList)
      const formatValue = (value) => {
        if (value === null || value === undefined || value === "") {
          return "";
        }
        const numericValue = parseFloat(value);
        return Number.isFinite(numericValue) ? numericValue.toFixed(1) : "";
      };

      tmpCommission = tmpCommission.map(item => ({
        ...item,
        StoreId: parseInt(item.StoreId),
        Commission: formatValue(item.Commission),
        NonStockCommission: formatValue(item.NonStockCommission),
        OverHead: formatValue(item.OverHead)
      }));
      setSalesStoreCommission(tmpCommission);
    }
  }, [salesPersonId, salesCommission])

  useEffect(() => {
    let tmpList = addDisabledKey(storeList, salesStoreCommission)
    setTmpSelectedStoreList(tmpList)
  }, [salesStoreCommission])

  // const commissionData = useMemo(() => salesCommission?.[0]?.SalesCommission || [], [salesCommission]);

  // Function to handle change in input fields
  const handleSelectChange = (index, key, value) => {
    setSalesStoreCommission(prevState => {
      // Create a copy of the salesCommission array
      let updatedSalesCommission = [...prevState];

      // Check if the array doesn't have an item at the specified index
      if (!updatedSalesCommission[index]) {
        // Create a new item with default values
        updatedSalesCommission[index] = {
          "IsDeleted": false,
          StoreId: '', // Provide default value for StoreId
          Commission: '', // Provide default value for Commission
          NonStockCommission: '', // Provide default value for Non Stock Commission
          OverHead: '' // Provide default value for OverHead
        };
      }

      // Update the value at the specified index and key
      const regex = /^\d*\.?\d{0,1}$/;
      if (key !=='StoreId') {
        if(regex.test(value)){
          updatedSalesCommission[index][key] = value;
        }
      }
      else{
        updatedSalesCommission[index][key] = parseInt(value);
      }
      
      return updatedSalesCommission;
    });

  };

  // setting store list data using memo
  const storeData = useMemo(() => {
    var stores = [];
    return stores.concat(storeList);
  }, [storeList])

  const hideModelData = () => {
    setSalesStoreCommission([])
    setTmpSelectedStoreList([])
    setSelectedEmployee(null)
    hideModel()
  }
  
  return (
    <Fragment>
      <Model isOpen={isOpen} size="l" dialogClassName="modal-90w">
        <Modal.Header closeButton onClick={hideModelData} className="border-0 pb-0">
          <Modal.Title>{salesPersonId ? 'Edit Sales-Person' : "Add Sales-Person"}</Modal.Title>
        </Modal.Header>

        <Form handleSubmit={e => handleSubmit(e, {userName: state.userName, salesStoreCommission})} validated={validated}>
          <ModelBody>
            <Table responsive className="no-wrap bg-border-none">
              <tbody>
                <tr>
                  <td colSpan="3">
                    {salesPersonId ? (
                      <Input label={"Name"} ids={'salesPersonCategory'} handleChange={handleChange} value={state.userName} validate={true} disabled={salesPersonId} />
                    ) : (
                      <BootForm.Group controlId="salesPersonEmployee">
                        <BootForm.Label className="w-100">Name<span className="text-danger">*</span></BootForm.Label>
                        <ReactSelect
                          inputId="salesPersonEmployee"
                          classNamePrefix="employee-select"
                          isSearchable
                          isClearable
                          placeholder="Search employee by name or email"
                          options={employeeOptions}
                          value={selectedEmployee}
                          formatOptionLabel={formatEmployeeOption}
                          filterOption={filterEmployee}
                          onChange={onEmployeeChange}
                        />
                        {/* visually-hidden required field keeps Bootstrap form validation blocking an empty submit */}
                        <input
                          type="text"
                          tabIndex={-1}
                          autoComplete="off"
                          required
                          value={selectedEmployee ? selectedEmployee.label : ""}
                          onChange={() => {}}
                          style={{ opacity: 0, height: 0, width: 0, position: "absolute" }}
                        />
                        {validated && !selectedEmployee ? (
                          <div className="text-danger" style={{ fontSize: "0.8rem" }}>Name is required</div>
                        ) : null}
                      </BootForm.Group>
                    )}
                  </td>
                </tr>
                <tr>
                  <th className="w-100">
                    <BootForm.Label className="mb-0">Select Store</BootForm.Label>
                  </th>
                  <th>
                    <BootForm.Label className="mb-0">Stock Commission %</BootForm.Label>
                  </th>
                  <th>
                    <BootForm.Label className="mb-0">Non Stock Commission %</BootForm.Label>
                  </th>
                  <th>
                    <BootForm.Label className="mb-0">Overhead %</BootForm.Label>
                  </th>
                </tr>
                {!_.isEmpty(storeData) ? _.map(storeList, (val, index) => (
                  <tr key={val.value}>
                    <td>
                      <Select result={storeData} ids="StoreId" validate={(index === 0 ? true : false)} value={salesStoreCommission?.[index]?.StoreId} disabled={salesStoreCommission?.[index]?.IsAssignedToCustomer} handleChange={e => handleSelectChange(index, 'StoreId', e.target.value)} optdisabled={tmpSelectedStoreList} />
                    </td>
                    <td>
                      <Input ids={`Commission`} value={salesStoreCommission?.[index]?.Commission ?? ""} handleChange={e => handleSelectChange(index, 'Commission', e.target.value)} />
                    </td>
                    <td>
                      <Input ids={`NonStockCommission`} value={salesStoreCommission?.[index]?.NonStockCommission ?? ""} handleChange={e => handleSelectChange(index, 'NonStockCommission', e.target.value)} />
                    </td>
                    <td>
                      <Input ids={`OverHead`} value={salesStoreCommission?.[index]?.OverHead ?? ""} handleChange={e => handleSelectChange(index, 'OverHead', e.target.value)} />
                    </td>
                  </tr>
                )) : null}
              </tbody>
            </Table>
          </ModelBody>
          <ModelFooter>
            <Button handleClick={hideModelData} variant="secondary" type="button">
              Close
            </Button>
            <Button variant="primary" type="submit">
              {isLoading ? (<div className="spinner-border"></div>) : "Save"}
            </Button>
          </ModelFooter>
        </Form>
      </Model>
    </Fragment>
  )
}

// export default AddEdit;
const mapStateToProps = ({ SalesPersonCategory }) => {
  return {
    SalesPersonCategory
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSalesCommission: (token, userId) => dispatch({ type: SALES_PERSON_COMMISSION_REQUEST, token, userId }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddEdit);
